import _ from "underscore";
// Turn something like this:
//     "reservation[primarySku][id]", "JH30_6"
// ...into something like this:
//     { reservation: { primarySku: { id: "JH30_6" } } }
// Useful for turning form values from an event handler into objects to be
// merged into your state object.
// @param name A field name, in the form "parent[child][child]"
// @param value The deepest value in the returned object
// @returns {object} A nest of objects where the deepest value is `value` and
//   the keys, from root inward, correspond to the individual parts of `name`
function nestFormValue(name, value) {
  var NAME_REG;

  // Captures each part of this name separately, so that an input like this:
  //     "reservation[primarySku][id]"
  // ...turns into an array like this:
  //     ["reservation", "[primarySku]", "[id]"]
  // We strip out the square brackets later, with our `replace`
  NAME_REG = /(^[^[]+|\[.+?])/g;

  return _.reduceRight(
    name.match(NAME_REG),
    function (patch, part) {
      var newPatch = {};
      newPatch[part.replace(/^\[|\]$/g, "")] = patch;
      return newPatch;
    },
    value
  );
}

export default nestFormValue;
